import React, { useEffect, useState } from 'react'
import { Button, Card, Form, Modal } from 'react-bootstrap'
import { Table, Tbody, Td, Th, Thead, Tr } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import { BsTrashFill } from 'react-icons/bs'
import { LuGraduationCap } from 'react-icons/lu'
import toast from 'react-hot-toast'
import { useAuth } from './AuthContext'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import { useInstitute } from './commonComponents/InstituteContext'

const HARDCODED_NOTIFICATIONS = [
  {
    id: 1,
    user_id: 101,
    message: 'Your fee payment is due by the end of this month.',
    expiry_date: '2026-08-15',
    status: 'not_removed',
  },
  {
    id: 2,
    user_id: 102,
    message: 'Parent-teacher meeting scheduled for next Friday.',
    expiry_date: '2026-07-31',
    status: 'not_removed',
  },
  {
    id: 3,
    user_id: 103,
    message: 'Library books must be returned before the exam week.',
    expiry_date: '2026-08-05',
    status: 'removed',
  },
  {
    id: 4,
    user_id: 104,
    message: 'Sports day registration is now open for all students.',
    expiry_date: '2026-09-01',
    status: 'not_removed',
  },
  {
    id: 5,
    user_id: 105,
    message: 'Please update your profile details in the portal.',
    expiry_date: '2026-08-20',
    status: 'removed',
  },
]

export default function Notification() {
  const { logout } = useAuth()
  const { isCollapsed } = useSidebar()
  const { logo } = useInstitute()
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [notificationList, setNotificationList] = useState(HARDCODED_NOTIFICATIONS)
  const [selectedNotification, setSelectedNotification] = useState(null)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1

        setMarginLeft(
          isCollapsed
            ? `${collapsedWidth + gap}px`
            : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }

      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

  const displayedNotifications = notificationList.slice(0, itemsPerPage)

  const formatDate = (date) =>
    new Date(date).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    })

  const formatStatus = (status) =>
    status === 'removed' ? 'Removed' : 'Not Removed'

  const tableHeaderStyle = {
    fontSize: '13px',
    fontWeight: '600',
    padding: '16px',
    border: 'none',
    borderBottom: '1px solid #D1D3D4',
    textAlign: 'left',
    color: '#111827',
    fontFamily: 'Inter, system-ui, sans-serif',
  }

  const tableCellStyle = {
    fontSize: '14px',
    padding: '16px',
    border: 'none',
    color: '#111827',
    textAlign: 'left',
    fontFamily: 'Inter, system-ui, sans-serif',
  }

  const handleDeleteNotification = () => {
    if (!selectedNotification) return

    setNotificationList((prev) =>
      prev.filter((item) => item.id !== selectedNotification.id),
    )
    toast.success('Notification deleted successfully')
    setShowDeleteModal(false)
    setSelectedNotification(null)
  }

  return (
    <>
      <style>
        {`
          .table td {
            user-select: text;
            overflow: visible !important;
          }
          .updates-page-header .dropdown-menu {
            z-index: 9999 !important;
          }
        `}
      </style>
      <div
        style={{
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          paddingLeft: isCollapsed ? '12px' : '12px',
          paddingRight: isCollapsed ? '12px' : '12px',
        }}
      >
        <div
          className="container-fluid p-0"
          style={{
            marginTop: typeof window !== 'undefined' && window.innerWidth < 992 ? '55px' : '-12px',
            paddingLeft: '0px',
            paddingRight: '0px',
          }}
        >
          <div style={{ marginLeft: isMobile ? '0px' : '-40px' }}>
            <div
              className="d-flex justify-content-between align-items-center updates-page-header"
              style={{
                background: '#F3F4F6',
                paddingLeft: isMobile ? '16px' : '28px',
                paddingRight: isMobile ? '16px' : '28px',
                paddingTop: '12px',
                paddingBottom: '12px',
                overflow: 'visible',
                borderBottom: '1px solid #D1D3D4',
                width: '100%',
                maxWidth: '100%',
                boxSizing: 'border-box',
                position: 'relative',
                zIndex: 20,
                gap: '12px',
              }}
            >
              <div className="d-flex align-items-center gap-3" style={{ flex: 1, minWidth: 0 }}>
                <div
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    overflow: 'hidden',
                    background: '#223843',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}
                >
                  {!logoError && logo ? (
                    <img
                      src={logo}
                      alt="School Logo"
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      onError={() => setLogoError(true)}
                    />
                  ) : (
                    <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                  )}
                </div>

                <h3
                  className="m-0 fw-bold"
                  style={{
                    letterSpacing: '-0.02em',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    fontSize: 'clamp(18px, 2.5vw, 22px)',
                    color: '#223843',
                    lineHeight: '1.2',
                    fontFamily: 'Inter, system-ui, sans-serif',
                  }}
                >
                  Updates
                </h3>
              </div>

              {!isMobile && (
                <div
                  className="d-flex align-items-center"
                  style={{ flexShrink: 0, position: 'relative', zIndex: 30 }}
                >
                  <ProfileDropdown logout={logout} />
                </div>
              )}
            </div>
          </div>
        </div>

        <div
          className="container-fluid p-0 mt-4"
          style={{
            minHeight: '100vh',
            paddingLeft: isMobile ? '12px' : isCollapsed ? '32px' : '40px',
            paddingRight: isMobile ? '12px' : '32px',
            paddingTop: '32px',
            paddingBottom: '32px',
            maxWidth: '100%',
            overflowX: isMobile ? 'hidden' : 'visible',
            boxSizing: 'border-box',
          }}
        >
          <div
            className="d-flex justify-content-between align-items-center mb-4"
            style={{
              gap: '12px',
              paddingRight: isMobile ? '0px' : '0',
              boxSizing: 'border-box',
            }}
          >
            <div className="d-flex align-items-center gap-3" style={{ minWidth: 0, flexWrap: isMobile ? 'wrap' : 'nowrap' }}>
              <div
                className="d-flex align-items-center"
                style={{
                  backgroundColor: '#ffffff',
                  padding: isMobile ? '8px 10px' : '8px 16px',
                  borderRadius: '8px',
                  gap: '8px',
                  border: '1px solid #D1D3D4',
                  maxWidth: '100%',
                  boxSizing: 'border-box',
                }}
              >
                <span style={{ color: '#6b7280', fontSize: '13px', whiteSpace: 'nowrap', fontFamily: 'Inter, system-ui, sans-serif' }}>
                  Show:
                </span>
                <Form.Select
                  className="w-auto"
                  value={itemsPerPage}
                  onChange={(e) => setItemsPerPage(parseInt(e.target.value))}
                  style={{
                    borderRadius: '6px',
                    border: '1px solid #D1D3D4',
                    backgroundColor: '#ffffff',
                    color: '#111827',
                    fontSize: '13px',
                    fontWeight: '500',
                    padding: '4px 32px 4px 12px',
                    minWidth: isMobile ? '120px' : '140px',
                    maxWidth: '100%',
                    cursor: 'pointer',
                    height: '36px',
                    fontFamily: 'Inter, system-ui, sans-serif',
                  }}
                >
                  <option value="10">10 per page</option>
                  <option value="20">20 per page</option>
                  <option value="30">30 per page</option>
                </Form.Select>
              </div>
            </div>
          </div>

          <Card
            className="table-card"
            style={{
              border: '1px solid #D1D3D4',
              borderRadius: '12px',
              overflow: isMobile ? 'hidden' : 'visible',
              backgroundColor: '#ffffff',
              position: 'relative',
              maxWidth: '100%',
            }}
          >
            <div
              className="table-wrapper"
              style={{
                overflowX: 'auto',
                overflowY: 'visible',
                position: 'relative',
                borderRadius: '12px',
              }}
            >
              <Table
                className="table mb-0"
                style={{
                  borderRadius: '12px',
                  overflow: 'visible',
                  position: 'relative',
                  marginBottom: '0',
                }}
              >
                <Thead>
                  <Tr style={{ backgroundColor: '#F3F4F6' }}>
                    <Th style={tableHeaderStyle}>Message</Th>
                    <Th style={tableHeaderStyle}>Expiry Date</Th>
                    <Th style={{ ...tableHeaderStyle, textAlign: 'center' }}>Action</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {displayedNotifications.length > 0 ? (
                    displayedNotifications.map((notification, index) => (
                      <Tr
                        key={notification.id}
                        style={{
                          backgroundColor: index % 2 === 0 ? '#ffffff' : 'rgba(243, 244, 246, 0.4)',
                          borderBottom: '1px solid #E5E7EB',
                        }}
                      >
                        <Td style={tableCellStyle}>{notification.message}</Td>
                        <Td style={tableCellStyle}>{formatDate(notification.expiry_date)}</Td>
                       
                        <Td className="text-center" style={{ padding: '16px', border: 'none' }}>
                          <button
                            type="button"
                            onClick={() => {
                              setSelectedNotification(notification)
                              setShowDeleteModal(true)
                            }}
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '6px',
                              height: '36px',
                              padding: '0 14px',
                              borderRadius: '8px',
                              border: '1px solid #FECACA',
                              backgroundColor: '#FEF2F2',
                              color: '#DC2626',
                              fontSize: '13px',
                              fontWeight: '600',
                              fontFamily: 'Inter, system-ui, sans-serif',
                              cursor: 'pointer',
                              transition: 'all 0.2s ease',
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = '#DC2626'
                              e.currentTarget.style.color = '#ffffff'
                              e.currentTarget.style.borderColor = '#DC2626'
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = '#FEF2F2'
                              e.currentTarget.style.color = '#DC2626'
                              e.currentTarget.style.borderColor = '#FECACA'
                            }}
                            title="Delete Notification"
                          >
                            <BsTrashFill size={14} />
                          </button>
                        </Td>
                      </Tr>
                    ))
                  ) : (
                    <Tr>
                      <Td colSpan={5} style={{ ...tableCellStyle, textAlign: 'center', color: '#6b7280' }}>
                        No notifications found.
                      </Td>
                    </Tr>
                  )}
                </Tbody>
              </Table>
            </div>
          </Card>
        </div>
      </div>

      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered size="lg">
        <Modal.Header closeButton closeVariant="white" className="bg-danger text-white">
          <Modal.Title>Delete Notification</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-2 fw-semibold" style={{ letterSpacing: '1px' }}>
            Are you sure you want to delete this notification for user{' '}
            <strong>{selectedNotification?.user_id}</strong>?
          </p>
          <hr />
          <div className="mt-3 text-muted fw-semibold" style={{ letterSpacing: '1px' }}>
            This action is irreversible and the notification will be removed from the list.
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDeleteNotification}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
